import api from '../../../store/api';
import {unwrapData, type ApiEnvelope} from '../../../store/apiResponse';
import {parseTotalCount, type GroupCallHistoryPage, type GroupCallHistoryQuery, type GroupCallHistorySession} from './groupCallHistoryTypes';

export const groupCallHistoryApi = api.injectEndpoints({
    endpoints: (builder) => ({
        fetchGroupCallSessions: builder.query<GroupCallHistoryPage, GroupCallHistoryQuery>({
            query: (params) => ({
                url: '/api/v1/group-call-sessions',
                params,
            }),
            transformResponse: (
                response: ApiEnvelope<GroupCallHistorySession[]> | GroupCallHistorySession[],
                meta,
            ) => {
                const sessions = unwrapData(response);
                if (!Array.isArray(sessions)) {
                    throw new Error('Unsupported group call history response');
                }
                return {
                    sessions,
                    totalCount: parseTotalCount(meta?.response?.headers.get('x-total-count'), sessions.length),
                };
            },
        }),
    }),
});

export const {useFetchGroupCallSessionsQuery} = groupCallHistoryApi;
